import cn from 'classnames';
import T from 'prop-types';
import React, { useEffect } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useMount } from 'react-use';
import NavProjectSelect from '../../../../../components/select/jobSelect/NavProjectSelect';
import useProjectsList from '../../../../../hooks/useProjectsList';
import { useNew3dBookmark } from '../../../../../hooks/useShareLinkParams';
import { getProjectById, getUserProfile, setCurrentProject } from '../../../../../redux/actions';
import { alertConstants } from '../../../../../redux/constants';
import { profileSelectors } from '../../../../../redux/selectors/profile';
import routes from '../../../../../routes/constants';
import text from '../../../../../text';
import { jobHasPointCloud } from '../../../../../utilities/job';
import { isDemoProject } from '../../../../../utilities/project';
import ShareLinkNav from './ShareLinkNav';
import { useRedirect } from '../../../../../hooks/useRedirect';
var Viewer3DNav = function(param) {
    var className = param.className, showShareLink = param.showShareLink;
    var isAdmin = useSelector(profileSelectors.getIsAdmin);
    var userProfileState = useSelector(function(state) {
        return state.profileReducer;
    }).userProfileState;
    var is3dViewerAccessibleToUser = useSelector(profileSelectors.get3dViewerEnabled);
    var currentProject = useSelector(function(state) {
        return {
            currentProject: state.project.currentProject
        };
    }).currentProject;
    var redirect = useRedirect();
    var dispatch = useDispatch();
    var projectId = useParams().projectId;
    var new3dBookmark = useNew3dBookmark();
    var _useProjectsList = useProjectsList({
        isAdmin: isAdmin,
        filterPredicate: function(project) {
            return (is3dViewerAccessibleToUser || isDemoProject(project)) && jobHasPointCloud(project);
        }
    }), projects = _useProjectsList.projects, isLoading = _useProjectsList.isLoading;
    useMount(function() {
        dispatch(getUserProfile());
    });
    useEffect(function() {
        if (projectId) {
            dispatch(getProjectById(projectId, {
                includeJobs: true,
                includePointCloud: true
            }));
        }
        // if current project is a demo, reset the current project state so returning to the file manager
        return function() {
            if ((currentProject === null || currentProject === void 0 ? void 0 : currentProject.id) && isDemoProject(currentProject)) dispatch(setCurrentProject(null));
        };
    }, [
        projectId
    ]);
    return /*#__PURE__*/ React.createElement(Nav, {
        className: cn('Title', className)
    }, /*#__PURE__*/ React.createElement(Navbar, null, /*#__PURE__*/ React.createElement("span", null, "".concat(text(isAdmin ? 'administrationViewer3D' : 'viewer3D'), ":")), userProfileState !== 'loading' && /*#__PURE__*/ React.createElement(NavProjectSelect, {
        projects: projects,
        isLoading: isLoading,
        onProjectChange: function(nextProject, prevProject) {
            if (!prevProject || nextProject.id !== prevProject.id) {
                redirect.push(routes.view3DExternal.project(nextProject.id));
                dispatch({
                    type: alertConstants.ALERT_RESET
                });
            }
        }
    }), /*#__PURE__*/ React.createElement(ShareLinkNav, {
        show: showShareLink,
        new3dBookmark: new3dBookmark
    })));
};
Viewer3DNav.propTypes = {
    className: T.string
};
export default Viewer3DNav;
